import type { APIListingEvent } from "models/types/api-listing";

export function sortEventsMostRecentFirst(
  events: APIListingEvent[],
): APIListingEvent[] {
  return events.sort(
    (a: APIListingEvent, b: APIListingEvent) =>
      new Date(b.starts_at).getTime() - new Date(a.starts_at).getTime(),
  );
}
